import {createContext, useContext} from "react";
import type {HeimdallUser} from "~/routes/_withAuthenticationStatus/-types";

type HeimdallUserContextData = HeimdallUser;

export const HeimdallUserContext = createContext<HeimdallUserContextData | undefined>(undefined);

export function useHeimdallUser(): HeimdallUserContextData {
    const heimdallUserContextData = useContext(HeimdallUserContext);
    if (heimdallUserContextData === undefined) {
        throw new Error("HeimdallUserContext.Provider not found");
    }

    return heimdallUserContextData;
}
